module.exports = "/* eslint react/no-multi-comp: 0, react/prop-types: 0, import/no-webpack-loader-syntax: off */\nimport React from 'react';\nimport { UncontrolledTooltip } from 'reactstrap';\n\nexport default function Example() {\n  return (\n    <div>\n      <p>Somewhere in here is a <a href=\"#link\" id=\"UncontrolledTooltipExample\">tooltip</a>.</p>\n      <UncontrolledTooltip placement=\"right\" target=\"UncontrolledTooltipExample\">\n        Hello world!\n      </UncontrolledTooltip>\n    </div>\n  );\n}\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/components/docs/components/Tooltips/TooltipUncontrolled.js
// module id = 363
// module chunks = 0